import * as React from 'react';

import { QuickscanDataContext } from '../context/QuickscanDataContext';
import { Actions, ManageableQuickscanData } from '../types';

export const StepOne = () => {
    const [quickscanDataState, quickscanDataDispatch] =
        React.useContext<ManageableQuickscanData>(QuickscanDataContext);

    return (
        <div className={'c-quickscan__form-group'}>
            <div className={'c-form__box'}>
                <h4 className={'c-form__box__title'}>Gegevens van de onderneming</h4>
                <div className={'c-form__row'}>
                    <div
                        className={`c-quickscan__form-field ${
                            quickscanDataState.validation.fields.organisation
                                ? ''
                                : 'c-form__field--invalid'
                        }`}
                    >
                        <label
                            htmlFor="field-organisation"
                            className="c-form__label"
                        >
                            Naam
                        </label>
                        <input
                            type="text"
                            id="field-organisation"
                            name="organisation"
                            className={
                                'c-form__field c-form__input-text'
                            }
                            value={quickscanDataState.quickscan.organisation}
                            onChange={(e) => {
                                quickscanDataDispatch({
                                    type: Actions.QuickscanDataTypes
                                        .SET_QUICKSCAN_DATA,
                                    payload: {
                                        quickscan: {
                                            ...quickscanDataState.quickscan,
                                            organisation: e.target.value,
                                        },
                                    },
                                });
                            }}
                            onKeyUp={(e) => {
                                quickscanDataDispatch({
                                    type: Actions.QuickscanDataTypes
                                        .VALIDATE_QUICKSCAN_STEP,
                                    payload: {
                                        step: quickscanDataState.currentStep,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div
                        className={`c-quickscan__form-field ${
                            quickscanDataState.validation.fields.address
                                ? ''
                                : 'c-form__field--invalid'
                        }`}
                    >
                        <label
                            htmlFor="field-address"
                            className="c-form__label"
                        >
                            Adres
                        </label>
                        <input
                            type="text"
                            id="field-address"
                            name="address"
                            className={
                                'c-form__field c-form__input-text'
                            }
                            value={quickscanDataState.quickscan.address}
                            onChange={(e) => {
                                quickscanDataDispatch({
                                    type: Actions.QuickscanDataTypes
                                        .SET_QUICKSCAN_DATA,
                                    payload: {
                                        quickscan: {
                                            ...quickscanDataState.quickscan,
                                            address: e.target.value,
                                        },
                                    },
                                });
                            }}
                            onKeyUp={(e) => {
                                quickscanDataDispatch({
                                    type: Actions.QuickscanDataTypes
                                        .VALIDATE_QUICKSCAN_STEP,
                                    payload: {
                                        step: quickscanDataState.currentStep,
                                    },
                                });
                            }}
                        />
                    </div>
                </div>
                <div className={'c-form__row'}>
                    <div
                        className={`c-quickscan__form-field ${
                            quickscanDataState.validation.fields.zipcode
                                ? ''
                                : 'c-form__field--invalid'
                        }`}
                    >
                        <label
                            htmlFor="field-zipcode"
                            className="c-form__label"
                        >
                            Postcode
                        </label>
                        <input
                            type="text"
                            id="field-zipcode"
                            name="zipcode"
                            className={
                                'c-form__field c-form__input-text'
                            }
                            value={quickscanDataState.quickscan.zipcode}
                            onChange={(e) => {
                                quickscanDataDispatch({
                                    type: Actions.QuickscanDataTypes
                                        .SET_QUICKSCAN_DATA,
                                    payload: {
                                        quickscan: {
                                            ...quickscanDataState.quickscan,
                                            zipcode: e.target.value,
                                        },
                                    },
                                });
                            }}
                            onKeyUp={(e) => {
                                quickscanDataDispatch({
                                    type: Actions.QuickscanDataTypes
                                        .VALIDATE_QUICKSCAN_STEP,
                                    payload: {
                                        step: quickscanDataState.currentStep,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div
                        className={`c-quickscan__form-field ${
                            quickscanDataState.validation.fields.city
                                ? ''
                                : 'c-form__field--invalid'
                        }`}
                    >
                        <label
                            htmlFor="field-city"
                            className="c-form__label"
                        >
                            Plaats
                        </label>
                        <input
                            type="text"
                            id="field-city"
                            name="city"
                            className={
                                'c-form__field c-form__input-text'
                            }
                            value={quickscanDataState.quickscan.city}
                            onChange={(e) => {
                                quickscanDataDispatch({
                                    type: Actions.QuickscanDataTypes
                                        .SET_QUICKSCAN_DATA,
                                    payload: {
                                        quickscan: {
                                            ...quickscanDataState.quickscan,
                                            city: e.target.value,
                                        },
                                    },
                                });
                            }}
                            onKeyUp={(e) => {
                                quickscanDataDispatch({
                                    type: Actions.QuickscanDataTypes
                                        .VALIDATE_QUICKSCAN_STEP,
                                    payload: {
                                        step: quickscanDataState.currentStep,
                                    },
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className={'c-form__row'}>
                <div
                    className={`c-quickscan__form-field--full c-quickscan__form-field ${
                        quickscanDataState.validation.fields.position
                            ? ''
                            : 'c-form__field--invalid'
                    }`}
                >
                    <label
                        htmlFor="field-position"
                        className="c-form__label"
                    >
                        Functie
                    </label>
                    <input
                        type="text"
                        id="field-position"
                        name="position"
                        className={
                            'c-form__field c-form__field--full c-form__input-text'
                        }
                        value={quickscanDataState.quickscan.position}
                        onChange={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes
                                    .SET_QUICKSCAN_DATA,
                                payload: {
                                    quickscan: {
                                        ...quickscanDataState.quickscan,
                                        position: e.target.value,
                                    },
                                },
                            });
                        }}
                        onKeyUp={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes
                                    .VALIDATE_QUICKSCAN_STEP,
                                payload: {
                                    step: quickscanDataState.currentStep,
                                },
                            });
                        }}
                    />
                </div>
            </div>
            <div className={'c-form__row'}>
                <div
                    className={`c-quickscan__form-field ${
                        quickscanDataState.validation.fields.firstName
                            ? ''
                            : 'c-form__field--invalid'
                    }`}
                >
                    <label htmlFor="field-firstname" className="c-form__label">
                        Voornaam
                    </label>
                    <input
                        type="text"
                        id="field-firstname"
                        name="firstname"
                        className={
                            'c-form__field c-form__field--half c-form__input-text'
                        }
                        value={quickscanDataState.quickscan.firstName}
                        onChange={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                                payload: {
                                    quickscan: {
                                        ...quickscanDataState.quickscan,
                                        firstName: e.target.value,
                                    },
                                },
                            });
                        }}
                        onKeyUp={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes
                                    .VALIDATE_QUICKSCAN_STEP,
                                payload: {
                                    step: quickscanDataState.currentStep,
                                },
                            });
                        }}
                    />
                </div>
                <div
                    className={`c-quickscan__form-field ${
                        quickscanDataState.validation.fields.lastName
                            ? ''
                            : 'c-form__field--invalid'
                    }`}
                >
                    <label htmlFor="field-lastname" className="c-form__label">
                        Achternaam
                    </label>
                    <input
                        type="text"
                        id="field-lastname"
                        name="lastname"
                        className={
                            'c-form__field c-form__field--half c-form__input-text'
                        }
                        value={quickscanDataState.quickscan.lastName}
                        onChange={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                                payload: {
                                    quickscan: {
                                        ...quickscanDataState.quickscan,
                                        lastName: e.target.value,
                                    },
                                },
                            });
                        }}
                        onKeyUp={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes
                                    .VALIDATE_QUICKSCAN_STEP,
                                payload: {
                                    step: quickscanDataState.currentStep,
                                },
                            });
                        }}
                    />
                </div>
            </div>
            <div className={'c-form__row'}>
                <div
                    className={`c-quickscan__form-field ${
                        quickscanDataState.validation.fields.otherInfo
                            ? ''
                            : 'c-form__field--invalid'
                    }`}
                >
                    <label htmlFor="field-emailaddress" className="c-form__label">
                        E-mailadres
                    </label>
                    <input
                        type="email"
                        id="field-emailaddress"
                        name="emailaddress"
                        className={
                            'c-form__field c-form__field--half c-form__input-text'
                        }
                        value={quickscanDataState.quickscan.otherInfo}
                        onChange={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                                payload: {
                                    quickscan: {
                                        ...quickscanDataState.quickscan,
                                        otherInfo: e.target.value,
                                    },
                                },
                            });
                        }}
                        onKeyUp={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes
                                    .VALIDATE_QUICKSCAN_STEP,
                                payload: {
                                    step: quickscanDataState.currentStep,
                                },
                            });
                        }}
                    />
                </div>

                <div
                    className={`c-quickscan__form-field ${
                        quickscanDataState.validation.fields.phoneNumber
                            ? ''
                            : 'c-form__field--invalid'
                    }`}
                >
                    <label htmlFor="field-phonenumber" className="c-form__label">
                        Telefoonnummer
                    </label>
                    <input
                        type="text"
                        id="field-phonenumber"
                        name="phonenumber"
                        className={
                            'c-form__field c-form__field--half c-form__input-text'
                        }
                        value={quickscanDataState.quickscan.phoneNumber}
                        onChange={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                                payload: {
                                    quickscan: {
                                        ...quickscanDataState.quickscan,
                                        phoneNumber: e.target.value,
                                    },
                                },
                            });
                        }}
                        onKeyUp={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes
                                    .VALIDATE_QUICKSCAN_STEP,
                                payload: {
                                    step: quickscanDataState.currentStep,
                                },
                            });
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
